import React from 'react';
import CompanySideNavigation, { COMPANY_PAGES } from './CompanySideNavigation';
import styled from 'styled-components';
import {
  SIDE_NAVIGATION_WIDTH,
  RightToggleButton,
  ToggleButtonWrapper,
} from '../Navbar/SideBar';
import autoAnimate from '@formkit/auto-animate';
import { NAVBAR_HEIGHT } from '../Navbar';

const Page = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: 100%;
`;

const Content = styled.div<{
  isSideNavigationOpen?: boolean;
}>`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: ${({ isSideNavigationOpen }) =>
    isSideNavigationOpen
      ? `calc(100vw - ${SIDE_NAVIGATION_WIDTH}px)`
      : '100vw'};
  height: 100%;
  padding: 0 64px;
  margin: 0 auto;
`;

const ViewPort = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  width: 100%;
  height: calc(100vh - ${NAVBAR_HEIGHT}px);
  overflow: hidden;
`;

const ScrollWrapper = styled.div`
  overflow-y: auto;
  display: flex;
  width: 100%;
  height: 100%;
  flex-direction: column;
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
  scrollbar-width: thin; /* Thin scrollbar for Firefox */

  /* Hide horizontal scrollbar */
  overflow-x: hidden;
`;

const EmptyDiv = styled.div`
  min-height: 72px;
  width: 100%;
  flex-shrink: 0;
`;

export default function CompanyPageWrapper({
  children,
  currentPage,
  contentStyle,
  scrollStyle,
  shouldAddEmptyDiv = true,
}: {
  children: React.ReactNode;
  currentPage: COMPANY_PAGES;
  contentStyle?: React.CSSProperties;
  scrollStyle?: React.CSSProperties;
  shouldAddEmptyDiv?: boolean;
}) {
  const [isNavigationOpen, setIsNavigationOpen] = React.useState(true);
  const parent = React.useRef(null);

  React.useEffect(() => {
    parent.current &&
      autoAnimate(parent.current, {
        duration: 500,
        easing: 'ease-in-out',
      });
  }, [parent]);

  return (
    <Page ref={parent}>
      {isNavigationOpen ? (
        <CompanySideNavigation
          onClose={() => setIsNavigationOpen(false)}
          currentPage={currentPage}
        />
      ) : (
        <ToggleButtonWrapper>
          <RightToggleButton onClick={() => setIsNavigationOpen(true)} />
        </ToggleButtonWrapper>
      )}
      <ViewPort>
        <ScrollWrapper style={scrollStyle}>
          <Content isSideNavigationOpen={isNavigationOpen} style={contentStyle}>
            {children}
            {shouldAddEmptyDiv && <EmptyDiv />}
          </Content>
        </ScrollWrapper>
      </ViewPort>
    </Page>
  );
}
